<template>
  <div
    class="color-picker-box"
  >
    <a-popover
      trigger="click"
      placement="leftBottom"
      overlay-class-name="color-pop"
    >
      <template slot="content">
        <chrome-picker
          :value="color"
          class="chrome-picker"
          @input="updateValue"
        />
      </template>
      <span
        class="color-picker-bg"
        :style="`background: ${color}`"
      />
    </a-popover>
  </div>
</template>
<script>
import { Chrome } from 'vue-color'
export default {
  components: {
    'chrome-picker': Chrome
  },
  props: {
    color: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isShow: false,
      parents: []
    }
  },
  methods: {
    updateValue (e) {
      this.$emit('setColor', e.hex)
      return false
    }
  }
}
</script>
<style lang="scss" scoped>
  .color-picker-box::v-deep {
    position: relative;
    display: inline-block;
    width: 32px;
    height: 32px;
    border-radius: 4px;
    vertical-align: middle;
    margin-left: 8px;
    margin-top: -3px;
    .color-picker-bg {
      width: 30px;
      height: 30px;
      display: inline-block;
      border-radius: 4px;
      border: 1px solid #d6d6d6;
    }
  }

</style>
<style lang="scss">
  .color-pop {
    .ant-popover-arrow {
      display: none;
    }
    .ant-popover-inner-content {
      padding: 0;
    }
  }
</style>
